import { alertMessagesArgsConfig } from '../../utils/event_constants';

export const updateCellDataAction = [
  {
    name: 'updateCellData',
    label: 'Update Cell Data',
    args: [
      {
        name: 'collection',
        label: 'collection',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
];
